/* This file is autogenerated by @oui/cli */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Svg, { Path } from "react-native-svg";
var SvgComponent = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        width: 18,
        height: 18,
        viewBox: "0 0 18 18",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx(Path, {
                d: "M4.3 4.15h1a1 1 0 0 0-1-1zm-.92 8.33h1a1 1 0 0 0-1-1zm0 3.57h-1a1 1 0 0 0 1.7.71zm3.57-3.57v-1a1 1 0 0 0-.7.3zm6-.44.63.78a1 1 0 0 0 .08-1.49zm-1.9-1.91.7-.7a1 1 0 0 0-.7-.3zM4.3 3.15H3v2h1.3zm-1.3 0a3 3 0 0 0-3 3h2a1 1 0 0 1 1-1zm-3 3v4.33h2V6.15zm0 4.33a3 3 0 0 0 3 3v-2a1 1 0 0 1-1-1zm3 3h.38v-2H3zm-.62-1v3.57h2v-3.57zm1.7 4.28 3.58-3.57-1.41-1.42-3.58 3.58zm2.87-3.28h4.75v-2H6.95zm4.75 0a3 3 0 0 0 1.88-.66l-1.25-1.56a1 1 0 0 1-.63.22zm1.96-2.15-1.9-1.9-1.42 1.4 1.9 1.92zm-2.61-2.2H6.3v2h4.75zm-4.75 0a1 1 0 0 1-1-1h-2a3 3 0 0 0 3 3zm-1-1V4.15h-2v3.98z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx(Path, {
                d: "M4.3 3c0-1.1.9-2 2-2H15a2 2 0 0 1 2 2v5.13a2 2 0 0 1-2 2h-.38v3.57l-3.57-3.57H6.3a2 2 0 0 1-2-2z",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                vectorEffect: "non-scaling-stroke"
            })
        ]
    }));
};
export default SvgComponent;
